import isString from 'lodash/isString'
import isTest from './env/isTest'

// unit tests were failing on Sundays due to inability to discriminate between "start of last week" and "last 7 days"
const TIME_NOW_FOR_UNIT_TEST = '6/16/2020'

// Parse the date as UTC
export default function parseDate(
  dateVal = isTest() ? TIME_NOW_FOR_UNIT_TEST : Date.now()
) {
  // non-Chrome cannot accept non-UTC dates with dashes, e.g. '10-31-2020'
  if (isString(dateVal) && dateVal.match(/\d{2}-\d{2}-\d{4}/)) {
    dateVal = dateVal.replace(/-/g, '/')
  }

  // always use UTC to avoid timezone issues, particularly on Safari
  return new Date(new Date(dateVal).toUTCString())
}

// gets the difference between the given date's UTC time and local timezone time
export function getUTCHourOffset(date) {
  const utcHourDiffRaw = date.getHours() - date.getUTCHours()
  const utcHourDiff = utcHourDiffRaw - (utcHourDiffRaw > 0 ? 24 : 0)
  return utcHourDiff
}
